export type THamburgerButton = {
  onClick: () => void;
};
export default function CWHamburgerButton({ onClick }: THamburgerButton) {
  return (
    <button
      className="xl1380:hidden ml-2 flex h-10 w-10 flex-col items-center justify-center focus:outline-none"
      aria-label="Open menu"
      onClick={onClick}
      type="button"
    >
      <span className="mb-1 block h-0.5 w-6 rounded bg-white transition-all" />
      <span className="mb-1 block h-0.5 w-6 rounded bg-white transition-all" />
      <span className="block h-0.5 w-6 rounded bg-white transition-all" />
    </button>
  );
}
